import { useState } from 'react'
import { useOutletContext, useNavigate } from 'react-router-dom'
import { Checkbox, Loader } from '@nazka/nazka.mapframe.components'
import { useDispatch } from 'react-redux'

import { setLoginToken } from '@services/local-storage.utils'
import { signInUser, getAccessToken } from '@services/auth.service'
import { connectWebSocket } from '@services/websocket.service'
import { useAuth } from '@App/components/AuthProvider/AuthProvider'
import { setActiveProject } from '@App/pages/MissionSetup/mission-setup.slice'

import './login-form.styl'

function LoginForm() {
  const dispatch = useDispatch()
  const { changedPasswordMessage } = useOutletContext()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [keepMeSignedIn, setKeepMeSignedIn] = useState(false)
  const [error, setError] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { setUser, isLoading: authIsLoading } = useAuth()

  const navigate = useNavigate()

  async function onSubmit(e) {
    e.preventDefault()
    setError(null)
    setIsLoading(true)

    try {
      const newUser = await signInUser(email, password)
      const token = await getAccessToken()

      if (keepMeSignedIn) {
        setLoginToken(token)
      }

      setUser(newUser)
      dispatch(setActiveProject(null))
      connectWebSocket(token)

      if (!authIsLoading && newUser) {
        navigate('/mission-setup')
      }
    }
    catch (e) {
      setError(e.message)
    }
    setIsLoading(false)
  }

  return (
    <form className="login-form" onSubmit={onSubmit}>
      <h1 className="login-form__title">
        Test Trap Planner
      </h1>
      <p className="login-form__intro">
        This application is only available to consortium members and field deployment stakeholders.
        You must request a login to be able to access the application.
      </p>
      {changedPasswordMessage && (
        <div className="login-form__success">
          {changedPasswordMessage}
        </div>
      )}
      <div className="login-form__inputs">
        <div className="login-form__inputs__field">
          <input
            type="text"
            placeholder="Email"
            autoComplete="email"
            value={email}
            onChange={(e) => {
              setError(null)
              setEmail(e.target.value)
            }}
            required
          />
        </div>
        <div className="login-form__inputs__field">
          <input
            type="password"
            placeholder="Password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => {
              setError(null)
              setPassword(e.target.value)
            }}
            required
          />
        </div>
      </div>
      <div className="login-form__actions">
        <Checkbox
          checked={keepMeSignedIn}
          onInputChange={e => setKeepMeSignedIn(e.target.checked)}
          text="Keep me signed in"
        />
        <button
          className="login-form__actions__forgot-password"
          type="button"
          onClick={() => navigate('/forgot-password')}
        >
          Forgot password?
        </button>
      </div>
      {error && (
        <div className="login-form__error">{error}</div>
      )}
      <button
        className="login-form__submit"
        type="submit"
      >
        {isLoading ? <Loader className="login-form__submit__spinner" /> : 'Sign in'}
      </button>
    </form>
  )
}

export default LoginForm
